<template>
  <v-btn icon
      @click="$emit('click')"
      v-tooltip="tooltipContent"
      :small="small"
  >
    <v-icon
      :small="small"
      :color="dark ? 'white' : 'grey darken-1'"
    >
      {{type}}
    </v-icon>
  </v-btn>
</template>

<script>
export default {
  props: {
    dark: Boolean,
    type: String,
    tooltip: {},
    small: Boolean
  },
  computed: {
    tooltipContent () {
      return window.innerWidth > 768 ? this.tooltip : null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/utils/RpIcon.vue